import React from 'react';
import { Box } from '@chakra-ui/react';

import ReactQuillComponent from './ReactQuillComponent';

function StaticText(props: any) {
  const { id, label } = props;

  return (
    <Box key={`static-text-${id}`} gridColumn="span 4/span 4">
      <ReactQuillComponent data={label} />
    </Box>
  );
}

export default StaticText;
